// removed by extract-text-webpack-plugin
module.exports = {"row-container":"TeamMember__row-container___1ZmCa","avatar":"TeamMember__avatar___1Cwbb","info-block":"TeamMember__info-block___1hSJ6"};